import { type IDrawService, type IGetDrawResultUseCase, NotFoundError } from '../../../domain/entry.js';

/**
 * Use case for retrieving the result of a specific draw.
 *
 * @param drawService - The service to interact with draw.
 * @returns Draw result data
 */
export function getDrawResultUseCase(drawService: IDrawService): IGetDrawResultUseCase {
  return {
    execute: async ({ product, drawNumber }): ReturnType<IGetDrawResultUseCase['execute']> => {
      const drawResult = await drawService.getDrawResultAsync(product, { drawNumber });

      if (!drawResult) {
        throw new NotFoundError(`Draw result for ${product} with draw number ${drawNumber} not found`);
      }

      return drawResult;
    },
  };
}
